export const Strings = {
  field: {
    projectLink: 'Project Link',
    feedback: 'Feedback',
    image: 'Image',
    category: 'Category',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    mobileNumber: 'Mobile Number',
    personalEmail: 'Personal Email',
    officialEmail: 'Official Email',
    accountHolderName: 'Account Holder Name',
    fatherName: 'Father Name',
    bankName: 'Bank Name',
    ifsc: 'IFSC',
    roleName: 'Role Name',
    accountType: 'Account Type',
    saving: 'Saving',
    current: 'Current',
    student: 'Student',
    accountNumber: 'Account Number',
    reenterAccountNumber: 'Re-enter Account Number',
    name: 'Name',
    enterOtherSourceName: 'Enter Other Source Name',
    description: 'Description',
    phone: 'Phone',
    resume: 'Resume/CV',
    source: 'Source',
    holidayName: 'Holiday Name',
    holidayDate: 'Holiday Date',
    holidayImage: 'Holiday Image',
    enterReferenceName: 'Enter Reference Name',
    preferredTimeSlots: 'Preferred Time Slots',
    addMember: 'Add Member',
    days: 'Days',
    max: 'Max',
    type: 'Leave Type',
    noOfDays: 'No Of Days',
    remaining: 'Remaining Leave',
    leaveReason: 'Leave Reason',
    projectName: 'Project Name',
    client: 'Client',
    date: 'Date',
    startDate: 'Start Date',
    estimatedEndDate: 'Estimated End Date',
    joinDate: 'Joining Date',
    rate: 'Rate',
    priority: 'Priority',
    timePeriod: 'Time period',
    addTeam: 'Add Team',
    uploadFile: 'Upload File',
    birthday: 'Birthday',
    gender: 'Gender',
    manager: 'Manager',
    companyName: 'Company Name',
    position: 'Position',
    address: 'Address',
    contraction: 'Contraction',
    monthlySalary: 'Monthly salary',
    annualCost: 'Annual Cost',
    revisedSalary: 'Revised salary',
    quarterlyAllowance: 'Quarterly Allowance',
    from: 'From',
    to: 'To',
    attachment: 'Attachment',
    status: 'Status',
    leave: 'Leave',
    request: 'Request',
    interviewTime: 'Interview Time',
    reason: 'Reason',
    reasonOfDecline: 'Reason Of Decline',
    member: 'Member',
    addNew: 'Add New',
    intern: 'Intern',
    projectInformation: 'Project Information',
    maritalStatus: 'Marital Status',
    expertise: 'Expertise',
    about: 'About',
    updatedBy: 'Updated By',
    reviewTo: 'Review To',
    enterName: 'Enter Name',
    link: 'Link',
    message: 'Message',
    reviewFrom: 'Review From',
    overallRating: 'Overall Rating',
    employeeId: 'Employee Id',
    referenceName: 'Reference Name',
    permanentAddress: 'Permanent Address',
    presentAddress: 'Present Address',
    sourceName: 'Source Name',
    dateAndTime: 'Date & Time',
    joiningDate: 'Joining Date',
    designation: 'Designation',
    department: 'Department',
    applyingFor: 'Applying For',
    aadharFront: 'Aadhar Front',
    aadharBack: 'Aadhar Back',
    panFront: 'Pan Front',
    panBack: 'Pan Back',
    approvedBy: 'Approved By',
  },
  button: {
    add: 'Add',
    addNew: 'Add New',
    updateInfo: 'Update Info',
    comment: 'Comment',
    downloadPdf: 'Download PDF',
    addProject: 'Add Project',
    login: 'Login',
    resetPassword: 'Reset Password',
    returnLogin: 'Return to Login',
    setPassword: 'Set Password',
    saveGeneralInformation: 'Save General Information',
    saveBankInformation: 'Save Bank Information',
    saveEducationalInformation: 'Save Educational Information',
    saveDocumentsInformation: 'Save Documents Information',
    addEmployee: 'Add Employee',
    saveEmployee: 'Save Employee',
    addCandidate: 'Add Candidate',
    saveMember: 'Save Member',
    addMore: 'Add More',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    schedule: 'Save & Schedule_Interview',
    addDesignation: 'Add Designation',
    addRole: 'Add Role',
    delete: 'Delete',
    addLeave: 'Add Leave',
    updateLeave: 'Update Leave',
    addHoliday: 'Add Holiday',
    saveCandidate: 'Save Candidate',
    submit: 'Submit',
    sendMessage: 'Send Message',
    addAsset: 'Add Asset',
    showChart: 'Show Chart',
    EditEmployee: 'Edit Employee',
    addLeaveDays: 'Add Leave & Days',
    changePeriod: 'Change Period',
    addSchedule: ' Add Schedule',
    clickHere: 'Click Here',
    editClient: 'Edit Client',
    editIntern: 'Edit Intern',
    editProject: 'Edit Project',
    editReview: 'Edit Review',
    saveIntern: 'Save Intern',
    sendToManager: 'Send To Manager',
    saveInDraft: 'Save In Draft',
    ok: 'Ok',
    updateProject: 'Update Project',
    addInterviewee: 'Add Interviewee',
    addIntern: 'Add Intern',
    addNewTask: 'Add New Task',
    clear: 'Clear',
    editAsset: 'Edit Asset',
    export: 'Export',
    addMember: 'Add Member',
    apply: 'Apply',
    exportpdf: 'Export to PDF',
    exportCsv: 'Export to CSV',
  },
  validation: {
    selectRequired: (field: string) => `Please select the ${field}`,
    fieldRequired: (field: string) => `Please enter the ${field}`,
    uploadRequired: (field: string) => `Please upload the ${field}`,
    pleaseSelect: (field: string) => `Please Select ${field}`,
    invalidEmail: 'Please enter the valid email address',
    invalidOfficialEmail: 'Please enter the @syncglob.com email',
    passwordNotMatch: 'Password and Confirm Password do not match',
    passwordMustContain: 'Password must contain at least 1 alphabet and 1 number',
    invalidAccountNumber: 'Please enter a valid Account Number',
    accountNumberNotMatch: 'Account Number and Re-enter Account Number do not match',
    invalidMobileNumber: 'Please enter a valid Mobile Number',
  },
  common: {
    attachFiles: 'Attach Files',
    copyright: '© 2023, SyncGlob Pvt. Ltd. All Rights Reserved.',
    developAutoResearch: 'Development | Automation Research | AI',
    success: 'Success!',
    na: 'NA',
    idNameEmailPhone: 'Search By Name, Email, Phone...',
    idEmailSource: 'Search By Email, Source...',
    failed: 'Failed!',
    selected: (prefix: string) => (prefix ? `${prefix} selected` : 'selected'),
    noRecord: 'No Record',
    pageNotFound: 'Page not found!',
    sorryCanNotFoundPage: 'Sorry, we couldn’t find the page you’re looking for.',
    search: 'Search...',
    idNameEmail: ' Search By Name, Email...',
    searchNameEmailPhoneRole: 'Search By Name, Email, Phone, Role... ',
    delete: 'Delete',
    active: 'Active',
    inactive: 'Inactive',
    welcomeBackCaption: (section: string) => `Welcome Back ${section}!`,
    activeInactiveTitle: (isActive: boolean) => (isActive ? 'Inactive' : 'Active'),
    deleteCaption: (section: string) =>
      `Are you sure you want to delete this ${section}? This action can not be undone.`,
    updateCaption: (section: string) =>
      `Are you sure you want to update this status as ${section}? This action can not be undone.`,
    activeInactiveCaption: (isActive: boolean, section: string) =>
      `Are you sure you want to ${
        isActive ? 'inactive' : 'active'
      } this ${section}? This action cannot be undone.`,
    confirmCaption: `Are you sure you want to proceed with this action? 
    it will activate the user in the system and send a welcome email to the user's official 
    and personal email ID's `,
    update: 'Update',
    department: 'Department',
    departments: 'Departments',
    addDepartment: 'Add Department',
    confirmLogout: 'Are you sure you want to Logout?',
    promoteAsEmployeeCaption:
      'Are you sure you want to promote as Employee, This action cannot be undone',
    promoteAsIntern: 'Promote As Intern',
    actionCanNotBePerformed:
      'Action can not be performed. The intern is currently inactive. Please active the intern to proceed.',
  },

  auth: {
    signIn: 'Sign In',
    signInYour: 'SignIn to your SyncGlob account',
    forgotPassword: 'Forgot Password?',
    useYourOfficial: 'Use your official email id to login',
    forgotPasswordHeading: 'Forgot Password',
    enterYourOfficial:
      'Enter your official email address, mobile number, or username to change your account password',
    setYourPassword: 'Set your password',
    enterAPassword: 'Enter a password to set it for your account',
    checkAPasswordLink: 'Please check a password reset link has sent to your registered email.',
  },
  profile: {
    generalInformation: 'General Information',
    personalInformation: 'Personal Information',
    bankInformation: 'Bank Information',
    educationProfessionalQualifications: 'Educational and Professional Qualifications',
    documents: 'Documents',
    officialInformation: 'Official Information',
    leaveInformation: 'Leave Information',
    assetsInformation: 'Assets Information',
    projectsTasksInfo: 'Projects/Tasks Information',
    reviewInformation: 'Review Information',
  },
  page_title: {
    login: 'Login',
    forgot_password: 'Forgot Password',
    set_password: 'Set Password',
    my_profile: 'Profile Settings',
    employees: 'Employees',
    candidates: 'Candidates',
    interns: 'Interns',
    designations: 'Designations',
    holidays: 'Holidays',
    addHoliday: 'Add Holiday',
    projects: 'Projects',
    offerLetter: 'Offer Letter',
    compensationLetter: 'Compensation Letter',
    memberDetails: 'Member Details',
    interviewees: 'Interviewees',
    details: 'Details',
    scheduleInterview: 'Schedule Interview',
    viewResume: 'View Resume',
    internDetails: 'Intern Details',
    aadharCard: 'Aadhar Card',
    panCard: 'Pan Card',
    notification: 'Notification',
    welcomeBack: 'Welcome Back',
    dashboard: 'Dashboard',
    reviewDetails: 'Review Details',
    myTeamMembers: 'My Team Members',
    eta: 'ETA',
  },
  status: {
    draft: 'Draft',
    sent: 'Sent',
    interview: 'Interview',
    Selected: 'Selected',
    active: 'Active',
    rejected: 'Rejected',
    inactive: 'Inactive',
    inProgress: 'In Progress',
    approved: 'Approved',
    declined: 'Declined',
    pending: 'Pending',
    InterviewCancelled: ' Interview Cancelled',
    intern: 'intern',
    employee: 'Employee',
    added: 'Added',
    InterviewScheduled: 'Interview Scheduled',
    completed: 'Completed',
    delivered: 'Delivered',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    hold: 'Hold',
    saved: 'Saved',
    good: 'Good',
    poor: 'Poor',
    average: 'Average',
    shortlisted: 'Shortlisted',
    decisionPending: 'Decision Pending',
    assigned: 'Assigned',
    repairing: 'Repairing',
    repaired: 'Repaired',
    damaged: 'Damaged',
    promotedAsEmployee: 'Promoted As Employee',
    candidate: 'Candidate',
    selectedAsEmployee: 'Selected As Employee',
    selectedAsIntern: 'Selected As Intern',
    internFinalWeek: 'Intern Final Week',
  },
  sidebar: {
    eta: 'ETA',
    taskList: 'Task List',
    taskManagement: 'Task Management',
    landingPage: 'Landing Page',
    clientTestimonial: 'Client Testimonial',
    portfolio: 'Portfolio',
    documents: 'Documents',
    members: 'Members',
    offerLetter: 'Offer Letter',
    compensationLetter: 'Compensation Letter',
    dashboard: 'Dashboard',
    employees: 'Employees',
    leaveAdmin: 'Leaves (Admin)',
    attendances: 'Attendances',
    shiftSechdule: 'Shift & Schedule',
    overtime: 'Overtime',
    leaves: 'Leaves',
    projects: 'Projects',
    taskBoard: 'Task Board',
    tasks: 'Tasks',
    configurations: 'Configurations',
    designations: 'Designations',
    roles: 'Roles',
    leaveManagement: 'Leave Management',
    holidays: 'Holidays',
    settings: 'Settings',
    logout: 'Logout',
    myProfile: 'My profile',
    clients: 'Clients',
    assets: 'Assets',
    memberDetail: 'Member Detail',
    candidates: 'Candidates',
    interviewees: 'Interviewees',
    interns: 'Interns',
    reviews: 'Reviews',
    dashBoard: 'Dashboard',
    overdueTasks: 'Overdue Tasks',
  },
  addCandidate: {
    manageCandidate: 'Manage Candidate',
    updateCandidate: 'Update Candidate',
    candidate: 'Candidate Details',
    enterTheCandidateInfo: 'Enter the candidate information to schedule interview with them',
    selectCandidate: 'Select Candidate Preferred Time Slot',
    interviewTime: 'Interview Time',
    interviewer: 'Interviewer',
    employee: 'Employee',
    candidateName: 'Candidate Name',
    update: 'Update',
    resume: 'Resume',
    areYouSureYouWantToRejected:
      'Are you sure you want to Rejected This Candidate? This action can not be undone.',
    pleaseEnterThePositionTheCandidate: 'Please enter the position the candidate is applying for',
  },
  rowActions: {
    view: 'View',
    inactive: 'Inactive',
    active: 'Active',
    scheduleInterview: 'Schedule Interview',
    delete: 'Delete',
    edit: 'Edit',
    promoteAsIntern: 'Promote as Intern',
    promoteAsEmployee: 'Promote as Employee',
    repair: 'Repair',
    rejected: 'Rejected',
    sendMail: 'Send Mail',
  },
  role: {
    forEverythingTo: 'For everything to work smoothly, You have to add roles in this order- ',
    andSoOn: 'and so on.',
    manager: 'Manager',
    intern: 'Intern',
    role: 'Role',
    addRoles: 'Add Role',
    candidate: 'Candidate',
    employee: 'Employee',
    thanksForKeeping: 'Thanks for keeping things organized!',
    note: 'Note :- ',
    roles: 'Roles',
  },
  projects: {
    managers: 'Managers',
    totalTasks: ' Total Tasks',
    remaining: 'Remaining',
    overdue: 'Overdue',
    inProgress: 'InProgress',
    assignedOn: 'Assigned On',
    managedBy: 'Managed By',
  },

  department: {
    department: 'Department',
    updateDepartment: 'Update Department',
  },

  designation: {
    designation: 'Designation',
    updateDesignation: 'Update Designation',
    addDesignation: 'Add Designation',
  },
  holiday: {
    holiday: 'Holiday',
    updateHoliday: 'Update Holiday',
  },
  clients: {
    client: 'Client',
    clients: 'Clients',
    addClient: 'Add Client',
    message: 'Message',
    viewProfile: 'View Profile',
    updateClient: 'Update Client',
    updateClientTestimonial: 'Update Client Testimonial',
    addTestimonial: 'Add Client Testimonial',
    clientTestimonial: 'Client Testimonial',
    clientName: 'Client Name',
  },
  portfolio: {
    portfolio: 'Portfolio',
    addPortfolio: 'Add Portfolio',
    updatePortfolio: 'Update Portfolio',
  },
  testimonial: {
    testimonial: 'Testimonial',
    addTestimonial: 'Add Testimonial',
    updateTestimonial: 'Update Testimonial',
    clientName: 'Client Name',
  },
  reviews: {
    reviews: 'Reviews',
    addReview: 'Add Review',
    overallRating: 'Overall Rating',
    communicationSkills: 'Communication Skills',
    behaviour: 'Behaviour',
    manager: 'Manager',
    employee: 'Employee',
    ratings: 'Ratings',
    learningSkills: 'Learning Skills',
    projectInvolvement: 'Project Involvement ',
    taskPerformance: 'Task Performance',
    reviewOf: 'Review Of',
    teamMember: 'Team Member',
    decisionMakingSkills: 'Decision Making Skills',
    fairTreatment: 'Fair Treatment',
    leadershipSkills: 'Leadership Skills',
    disciplineManners: 'Discipline and Manners',
  },
  caption: {
    delete: 'Are you sure you want to delete this role? This action cannot be undone.',
    inactive: 'Are you sure you want to active / inactive this role? This action cannot be undone.',
    thereAreNoSlots: 'There are no slots available for the selected date.',
  },
  addEmployee: {
    personal: 'Personal Information',
    emergency: 'Emergency Contact',
    relation: 'Relation',
    dateOfBirth: 'Date Of Birth',
    address: 'Address',
    phone: 'Phone',
    name: 'Name',
    manager: 'Manager',
    manageEmployee: 'Manage Employee',
    updateEmployee: 'Update Employee',
    maritalStatus: 'Marital Status',
    aboutMe: 'About Me',
    married: 'Married',
    unmarried: 'Unmarried',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    city: 'City',
    state: 'State',
    country: 'Country',
    postalCode: 'Postal Code',
    presentAddress: 'Present Address',
    permanentAddress: 'Permanent Address',
    sameAsPresentAddress: 'Same as Present Address',
    joiningDate: 'Joining Date',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    exportToCsv: 'Export to CSV',
    exportToPdf: 'Export to PDF',
    selectFieldYouWantToExport: 'Select Field You Want To Export',
    filterByMonth: 'Filter By Month',
    filterByProject: 'Filter By Project',
    filterByBoardName: 'Filter By Board Name',
  },
  addIntern: {
    manageIntern: 'Manage Intern',
    updateIntern: 'Update Intern',
    selectInterviewTime: 'Select Interview Time',
    interviewTime: 'Interview Time',
    interviewer: 'Interviewer',
    internName: 'Intern Name',
    saveIntern: 'Save Intern',
  },
  education: {
    education: 'Education and Professional Qualification',
    school: 'School',
    board: 'Board',
    from: 'From',
    degree: 'Degree',
    to: 'To',
    college: 'College',
    university: 'University',
    document: 'Document',
    secondaryEducation: 'Secondary Education',
    seniorSecondaryEducation: 'Senior Secondary Education',
    higherEducation: 'Higher Education',
    passedOutYear: 'Passed Out Year',
    courseName: 'Course Name',
    stream: 'Stream',
    schoolCollegeInstitute: 'School / College / Institute Name',
    degreeDiplomaCertificate: 'Degree / Diploma / Certificate',
    dateOfCompletion: 'Date of Completion',
    specialization: 'Specialization',
  },
  workExperience: {
    workExperience: 'Work Experience',
    companyName: 'Company Name',
    designationJobTitle: 'Designation / Job Title',
    fromDate: 'From Date',
    toDate: 'To Date',
    jobDescription: 'Job Description',
  },
  document: {
    documents: 'Documents',
    aadharCard: 'Aadhar Card',
    aadharCardFront: 'Aadhar Card Front',
    aadharCardBack: 'Aadhar Card Back',
    panCard: 'Pan Card',
    panCardFront: 'Pan Card Front',
    panCardBack: 'Pan Card Back',
    previewAadharCard: 'Preview Aadhar Card',
    previewPanCard: 'Preview Pan Card',
  },
  official: {
    official: 'Official Information',
    manager: 'Manager',
    joining: 'Joining Date',
  },
  leaveManagement: {
    sick: 'Sick Leaves',
    hospital: 'Hospitalization Leaves',
    casual: 'Casual Leaves',
    urgent: 'Urgent Leaves',
    paid: 'Paid Leaves',
    leaveManagement: 'Leave Management',
  },
  project: {
    project: 'Project',
    teamLeader: 'Team Leader',
    teamMembers: 'Team Members',
    description: 'Description',
    progress: 'Progress',
    team: 'Team',
    projectLeader: 'Project Leader',
    deadLine: 'Deadline',
    openTasks: 'Open Tasks',
    tasksCompleted: 'Tasks Completed',
  },
  assets: {
    assetName: 'Asset Name',
    assetUser: 'Asset User',
    assetsId: 'Assets Id',
    updateAssets: 'Update Assets',
    purchaseDate: 'Purchase Date',
    purchaseFrom: 'Purchase From',
    manufacturer: 'Manufacturer',
    model: 'Model',
    serialNumber: 'Serial Number',
    supplier: 'Supplier',
    condition: 'Condition',
    warranty: 'Warranty',
    cost: 'Cost',
    status: 'Status',
    addAsset: 'Add Asset',
    damaged: 'damaged',
    available: 'Available',
    assigned: 'assigned',
    description: 'Description',
    addVender: 'Add Vender',
    gst: 'GST',
    repair: 'Repair',
    repairPart: 'Repair Part',
    repairing: 'Repairing',
    repaired: 'Repaired',
    mobile: 'Mobile',
    laptop: 'Laptop',
    other: 'Other',
    otherAssetName: 'Other Asset Name',
    otherRepairPart: 'Other Repair Part',
    vendor: 'Vendor',
    assetsImage: 'Assets Image',
  },
  dialogHeading: {
    addOfferLetter: 'Add Offer Letter',
    addCompensation: 'Add Compensation',
  },
  leave: {
    totalRemaining: 'Total Remaining',
    totalTaken: 'Total Taken',
    totalAllow: 'Total Allow',
    fullDay: 'Full Day',
    firstHalf: '1st Half',
    secondHalf: '2nd Half',
    selectPeriodForLeave: 'Select Period For Leave',
    date: 'Date',
    taken: 'Taken',
    selectPeriod: 'Select Period',
    youAreRequesting: 'You are requesting for ',
    remainingLeaves: 'Remaining leaves',
    declinedLeave: 'Declined Leave',
    declinedCaption: `Are you sure you want to decline this leave? This action cannot be undone.`,
    yourLeaveIsSavedInDraft:
      'Your Leave is saved in draft. Now, you need to send it to the manager for approval.',
    actionSendToManager: 'Action > Send To Manager',
    totalAllowedLeaves: 'Total Allowed Leaves',
    hospitalReport: 'Hospital Report',
    lossOfPay: 'Loss Of Pay',
    takenLeaves: ' Total Taken Leaves',
    sendToManagerCaption:
      'Are you sure you want to forward this leave request to the manager ? This action cannot be undone.',
    lossOfPayError:
      'Please note that you have reached the maximum limit of paid leave, any further leave will be processed as loss of pay.',
    updateStatus: 'Update Status',
    name: 'Name',
    howManyDays: 'How Many Days',
    leaveType: 'Leave Type',
    approvedBy: 'Approved By',
    reason: 'Reason',
    addExistingLeave: 'Add Existing Leave',
  },
  dashboard: {
    caption:
      'Welcome to a new era of IT excellece where inovation meets excellece navigate through our intutive interface, explore our array of services, and experince the convenience  of cuttingedge techonology at your fingerprints.',
    attendence: 'Attendence',
    total: 'Total',
    onLeave: 'On Levae',
    present: 'Present',
    wfh: 'WFH',
    upcomingHolidays: 'Upcoming Holidays',
    taskOverview: ' Task Overview',
    completedTask: 'Completed Tasks',
    remainingTask: 'Remaining Tasks',
    myRemainingTask: 'My Remaining Tasks',
    onGoingTask: ' On Going Tasks',
    onHoldTask: 'On Hold Tasks ',
    projectSummary: ' Project Summary',
    employeeId: 'Employee Id',
    workedFor: 'Worked For',
    overdueTasks: 'Overdue Tasks',
    applyDate: 'Apply Date',
    interviewedBy: 'Interviewed By',
    approvedBy: 'Approved By',
    department: 'Department',
    designation: 'Designation',
    dueDate: 'Due Date',
    assignedOn: 'Assigned On',
    assignedBy: 'Assigned by',
    requestedLeaves: 'Requested Leaves',
    approvedLeaves: 'Approved Leaves',
    managedBy: 'Managed By',
    setThePriority: 'Set The Priority',
    mySchedule: 'My Schedule',
    byDate: 'By Date',
    byMonth: 'By Month',
    reviewedBy: 'Reviewed by',
    selectionDate: 'Selection Date',
    selectedInters: 'Selected Interns',
    selectedEmployees: 'Selected Employees',
    internShipFinalWeek: 'Internship Final Week',
    departed: 'Departed',
    duration: 'Duration',
    dataNotFound: 'Data Not Found!',
    youHaveToClickOnMembers:
      'You have to click on members to find the tasks of the members you are looking for ',
    noHoliday: '* There is no holiday in this month',
    selectedBy: 'Selected By',
    rejectedBy: 'Rejected By',
    rejectionDate: 'Rejection Date',
    companyGrowth: "Company's Growth",
    myOverdueTasks: 'My Overdue Tasks',
  },
  employeeDashborad: {
    projectName: 'Project Name',
    caption:
      'Welcometo a new era of IT excellece where inovation meets excellece navigate through our intutive interface, explore our array of services, and experince the convenience  of cuttingedge techonology at your fingerprints.',
    totalLeaves: 'Total Leaves',
    leavesTaken: ' Taken Leaves',
    totalLeave: 'Total Leaves',
    upcomingHolidays: 'Upcoming Holidays',
    projectsContribution: 'Projects Contribution',
    myProjects: 'My Projects',
    managedBy: 'Managed By:',
    assignedOn: 'Assigned On',
    taskOverview: 'Task Overview',
    total: 'Total',
    onGoing: 'On Going',
    remaining: 'Remaining',
    finished: 'Finished',
    runningProjects: 'Running Projects',
    leaveTaken: 'Leave Taken',
    runingTask: ' Runing Task',
    taskAssignment: ' Task Assignment',
    assets: 'My Assets',
    overDue: 'Over Due',
    remainingTasks: 'Remaining Tasks',
    myProjectLeaders: 'My Project Leaders',
    myRemainingNoOfTask: 'My Remaining no. of Task',
    allowedLeaves: 'Allowed Leaves',
    lopLeaves: 'LOP Leaves',
    youHaveNotTaken: 'You haven’t taken any leaves yet. Plan your time off wisely!',
  },
  taskBoard: {
    transactionHistory: 'Transaction History',
    dragAndDrop: 'Drag & drop files here, or click to select',
    dropTheFilesHere: 'Drop the files here ...',
    thisReplyWas: 'This reply was deleted.',
    addChecklist: 'Add Checklist',
    add: 'Add',
    edit: 'Edit',
    labels: 'Labels',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    activity: 'Activity',
    createaNewLabel: 'Create A New Label',
    enableColorBlindFriendlyMode: 'Enable colorblind friendly mode',
    startDate: 'Start Date',
    writeAComment: 'Write a comment...',
    reply: 'Reply',
    dueDate: 'Due Date',
    checklist: 'Checklist',
    save: 'Save',
    attachment: ' Attachment',
    screenshot2: 'Screenshot2',
    added9MinutesAgo: 'Added 9 minutes ago',
    comment: 'Comment',
    download: 'Download',
    delete: ' Delete',
    noLabelsFound: 'No Labels Found',
    addToCard: 'Add to Card',
    members: 'Members',
    dates: 'Dates',
    description: 'Description',
    background: 'Background',
    boardTittle: ' Board tittle',
    chooseFromGallery: ' Choose From Gallery',
    addACard: ' + Add a Ticket',
    addCard: 'Add',
    recentBoards: 'Recent Boards',
    teamNexus: 'Team Nexus',
    onion: 'Onion',
    petVesta: 'Pet Vesta',
    createBoard: 'Create Board',
    changeBackground: 'Change Background',
    title: 'Title',
    selectAColor: 'Select a color',
    removeColor: 'X Remove Color',
    createLabels: 'Create Labels',
    noBoardFound: 'No Board Found',
    searchProject: 'Search Project',
    boardAdmins: ' Board Admins',
    recentBackground: 'Recent Background',
    addedMembers: 'Added Members',
    admin: 'Admin',
    wantToShowInDashboard: 'want to show in task overview',
    CheckedIfYouWantToShowThisList: 'Checked, if you want to show this list in a task overview',
    saveList: 'Save list',
    addAnotherList: '+ Add Another List',
    makeCover: 'Make Cover',
    removeCover: 'Remove Cover',
    deleteContentOfCard:
      'All actions will be removed from the activity feed and you won’t be able to re-open the card. There is no undo.',
    deleteHeading: 'Delete ?',
    change: 'Change',
    overDue: 'Over Due',
    dueSoon: 'Due Soon',
    completed: 'Completed',
    removeFromBoard: 'Remove from board',
    time: 'Time',
    workspaceOwner: "Workspace's owner",
    searchBoard: 'Search Board',
    pdf: 'Pdf',
    boardMembers: 'Board Members',
    noMemberFoundInThisBoard: 'No members found in this board',
    taskBoardSignUp: 'Task Board SignUp',
    enterYourUserName: 'Enter Your Username',
    enterYourEmail: 'Enter Your Email',
    enterYourPassword: 'Enter Your Password',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    alreadyHaveAccount: 'Already have account?',
    welcomeToTaskBoard: 'Welcome! To Taskboard',
    dontHaveAnAccount: "Don't have an account? ",
    recoverYourPassword: 'Recover Your Password',
    recover: 'Recover',
    verificationCode: 'Verification Code',
    verified: 'Verified',
    enterYourVerificationCode: 'Enter Your Verification Code Here',
    resetPassword: 'Reset Password',
    enterYourNewPassword: 'Enter Your New Password',
    confirmYourPassword: 'Confirm Your Password',
    noLabel: 'No Label',
    noDate: 'No Date',
    unAssigned: 'Unassigned',
    cardsAssignedToMe: 'Cards assigned to me',
    assignee: 'Assignee',
    keyword: 'Keyword',
    noProjectsFound: 'No projects found',
    noAssigneeFound: 'No assignee found',
    addItem: '+ Add Item',
    searchBoardName: 'Search Board Name',
    cancel: 'Cancel',
  },
  tasks: {
    readyToWork: 'Ready To Work',
    doing: 'Doing',
    readyForReview: 'Ready For Review',
    done: 'Done',
    hold: 'hold',
    taskName: 'Task Name',
    projectName: 'Project Name',
    assignedBy: 'Assigned By',
    assignedOn: 'Assigned On',
    dueDate: 'Due Date',
    attachment: 'Attachment',
    labels: 'Labels',
    status: 'Status',
    checklist: 'Checklist',
    transaction: 'Transaction',
    comments: 'Comments',
    movedThisCard: ' moved this card ',
    totalTask: 'Total Task',
    attachments: 'Attachments',
    filterByDateRange: 'Filter By Date Range',
    filterByBoardName: 'Filter By Board Name',
    filterByAssignee: 'Filter By Assignee',
    assignee: 'Assignee',
    dateRange: 'Date Range',
    boardName: 'Board Name',
    selectBoardName: 'Select Board Name',
    selectAssignee: 'Select Assignee',
    selectDateRange: 'Select Date Range',
    sNo: 'S. No',
  },
  eta: {
    taskName: 'Task Name',
    description: 'Description',
    expectedTime: 'Expected Time (hour)',
    actualTime: 'Actual Time (hour)',
    status: 'Status',
    selectField: 'Select field you want to export',
    projectName: 'Project Name',
    assignedBy: 'Assigned By',
    assignedOn: 'Assigned On',
    startTime: 'Start Time',
    dueDate: 'Due Date',
    endTime: 'End Time',
    label: 'Label',
  },
  overDueTasks: {
    assignee: 'Assignee',
    boardName: 'Board Name',
    managedBy: 'Managed By',
    taskName: 'Task Name',
    startDateTime: 'Start Date & Time',
    deadLine: 'Deadline',
    submittedTime: 'Submitted Time',
  },
};
